import React from 'react';

export const NotionCalloutIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 18v-5.25m0 0a6.01 6.01 0 001.5-1.125a6.01 6.01 0 001.5-1.125m-3 2.25a6.01 6.01 0 01-1.5-1.125a6.01 6.01 0 01-1.5-1.125m3 2.25M9 11.25v-1.5a3.375 3.375 0 013.375-3.375h1.5a3.375 3.375 0 013.375 3.375v1.5M9 11.25h3m3 0h3m-3 0v-1.5a3.375 3.375 0 013.375-3.375h1.5a3.375 3.375 0 013.375 3.375v1.5" />
  </svg>
);
